import React from 'react'

export const Footer = () => {
  // let footerStyle = {
  //   position:"relative",
  //   top: "10vh",
  //   width: "100%"


  //}
  return (
    <footer className='bg-dark text-light py-3'>
      {/* <footer className='bg-dark text-light py-3' style={footerStyle}></footer> */}
      <p className='text-center'>
      Copyright &copy; 2022 My-React-App, Diba
      </p>
      
    </footer>
  )
}
